import { exportPtPlusOrderReportsApi } from 'redux/actions/adminPtPlus';
import * as moment from 'moment';

function formatDate(date) {
  return moment(date).format("YYYY-MM-DD")
}

const prepareDelOrderCsvData = (orderData) => {
  let tempCsvData = orderData.map(item => {

    let palletsCondition = 'NA';
    if (item?.palletDetails?.condition && item?.palletDetails?.condition.length > 0) {
      let condition = item.palletDetails.condition;
      let newType = item?.palletDetails?.newConditionType;

      // Checking if newType is not an empty string or undefined
      if (newType && newType.trim() !== '') {
        palletsCondition = `${condition} (${newType === 'HARDWOOD' ? 'HW' : 'SW'})`;
      } else {
        palletsCondition = condition;
      }
    }

    let palletSize = item?.palletDetails?.size || 'NA';
    if (palletSize === 'Custom') {
      let length = item?.palletDetails?.length || 'NA';
      let width = item?.palletDetails?.width || 'NA';
      let height = item?.palletDetails?.height || 'NA';

      palletSize = `${length}x${width}x${height}`;
    }

    let mappedData = {
      InvoiceNO: item?.orderDetails?.invoiceNumber || 'NA',
      ReferenceNumber: item?.orderDetails?.orderRefNumber || 'NA',
      PurchaseOrder: item?.orderDetails?.poNumber || 'NA',
      OrderNo: item?.orderDetails?.orderId || 'NA',
      BillToCompanyName: item?.orderDetails?.billToCompany?.replace(/,|\n|\r/g, " ") || 'NA',
      DeliveryLocationName: item?.orderDetails?.deliveryLocationName?.replace(/,|\n|\r/g, " ") || 'NA',
      DeliveryAddress: item?.orderDetails?.deliveryAddress?.replace(/,|\n|\r/g, " ") || 'NA',
      City: item?.addressDetails?.city?.replace(/,|\n|\r/g, " ") || 'NA',
      State: item?.addressDetails?.state?.replace(/,|\n|\r/g, " ") || 'NA',
      ZipCode: item?.addressDetails?.zipCode || 'NA',
      EquipmentRequirements: (item?.equipments && item?.equipments?.length > 0) ? item?.equipments?.join('; ') : 'NA',
      Material: item?.palletDetails?.material || 'NA',
      Condition: palletsCondition,
      PalletType: item?.palletDetails?.palletType || 'NA',
      Moisture: item?.palletDetails?.moisture || 'NA',
      Size: palletSize,
      Grade: item?.palletDetails?.grade || 'NA',
      OrderRequestDate: item?.orderDetails?.orderRequestDate || 'NA',
      RequestedDeliveryDate: item?.orderDetails?.requestDeliveryDate || 'NA',
      ActualDeliveryDate: item?.orderDetails?.actualDeliveryDate || 'NA',
      Status: item?.orderDetails?.status === 'CANCELLED' ? 'CANCELED' : (item?.orderDetails?.status || 'NA'),
      Quantity: item?.quantity || 'NA',
      FlatFee: item?.orderPayments?.flatFee ? `$${!isNaN(parseFloat(item.orderPayments.flatFee)) ? parseFloat(item.orderPayments.flatFee).toFixed(2) : 'NA'}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'NA',
      BidPrice: (item?.orderDetails?.bidPrice && item?.orderDetails?.bidPrice !== "0.0" && item?.orderDetails?.bidPrice !== "0.00") ? `$${item?.orderDetails?.bidPrice}` : 'NA',
      TotalAmount: item?.orderPayments?.totalAmount ? `$${item?.orderPayments?.totalAmount}` : 'NA',
      CustomerTaxPercentage: item?.orderPayments?.customerTaxPercent ? `${item?.orderPayments?.customerTaxPercent}%` : 'NA',
      CustomerTaxAmount: item?.orderPayments?.customerTaxAmount ? `$${item?.orderPayments?.customerTaxAmount}` : 'NA',
      ManagementFeePercentage: item?.orderPayments?.mgmtFeePercent ? `${item?.orderPayments?.mgmtFeePercent}%` : 'NA',
      ManagementFeeAmount: item?.orderPayments?.mgmtFeeAmount ? `$${item?.orderPayments?.mgmtFeeAmount}` : 'NA',
      TotalInvoiceAmount: item?.orderPayments?.totalInvoiceAmount ? `$${item?.orderPayments?.totalInvoiceAmount}` : 'NA',
      InvoiceDate: item?.orderPayments?.invoiceDate || 'NA',
      InvoicePeriod: item?.orderPayments?.invoicePeriod || 'NA',
      NetPaymentTerm: item?.orderPayments?.netPaymentTerm || 'NA',
      PaymentReceivedDate: item?.orderPayments?.paymentReceivedDate || 'NA',
      PaymentStatus: item?.orderPayments?.paymentStatus || 'NA',
      Comments: 'NA'
    }
    let adjustmentRows = [];
    if (item?.adjustmentDetails && item?.adjustmentDetails?.length > 0) {
      adjustmentRows = item.adjustmentDetails.map(adjustment => ({
        InvoiceNO: adjustment?.adjInvoiceId || 'NA',
        ReferenceNumber: 'NA',
        PurchaseOrder: 'NA',
        OrderNo: 'NA',
        BillToCompanyName: 'NA',
        DeliveryLocationName: 'NA',
        DeliveryAddress: 'NA',
        City: 'NA',
        State: 'NA',
        ZipCode: 'NA',
        EquipmentRequirements: 'NA',
        Material: 'NA',
        Condition: 'NA',
        PalletType: 'NA',
        Moisture: 'NA',
        Size: 'NA',
        Grade: 'NA',
        OrderRequestDate: 'NA',
        RequestedDeliveryDate: 'NA',
        ActualDeliveryDate: 'NA',
        Status: 'NA',
        Quantity: 'NA',
        FlatFee: 'NA',
        BidPrice: 'NA',
        TotalAmount: 'NA',
        CustomerTaxPercentage: 'NA',
        CustomerTaxAmount: 'NA',
        ManagementFeePercentage: 'NA',
        ManagementFeeAmount: 'NA',
        TotalInvoiceAmount: adjustment?.adjType === 'DEBIT' ? `-$${adjustment?.adjAmount}` : `+$${adjustment?.adjAmount}`,
        InvoiceDate: adjustment?.adjDate || 'NA',
        InvoicePeriod: 'NA',
        NetPaymentTerm: 'NA',
        PaymentReceivedDate: adjustment?.paymentDate || 'NA',
        PaymentStatus: adjustment?.invoiceStatus || 'NA',
        Comments: adjustment?.comments?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || 'NA'
      }));
    }

    if (adjustmentRows) return ([mappedData, ...adjustmentRows])
    else return mappedData
  })
  const finalCsvData = tempCsvData.flat()
  return finalCsvData;
}

const preparePickupOrderCsvData = (orderData) => {
  const finalCsvData = orderData.flatMap(item => {
    const baseData = {
      InvoiceNO: item?.invoiceId || 'NA',
      ReferenceNumber: item?.orderRefNumber,
      PurchaseOrder: item?.poNumber || 'NA',
      OrderNo: item?.orderId,
      CreditAcc: item?.companyName || 'NA',
      BillToCompanyName: item?.billToCompanyName?.replace(/,|\n|\r/g, " "),
      PickupLocationName: item?.pickupLocationInfo?.locationName?.replace(/,|\n|\r/g, " "),
      PickupAddress: item?.pickupLocationInfo?.address?.replace(/,|\n|\r/g, " "),
      City: item?.pickupLocationInfo?.city?.replace(/,|\n|\r/g, " "),
      State: item?.pickupLocationInfo?.state?.replace(/,|\n|\r/g, " "),
      ZipCode: item?.pickupLocationInfo?.zipCode,
      VendorName: item?.vendorName || 'NA',
      EquipmentRequirements: item?.equipmentRequirement || 'NA',
      OrdReqDate: item?.orderRequestedDate,
      ReqPickupDate: item?.requestedPickupDate,
      ActualPickupDate: item?.actualPickupDate || 'NA',
      InvoiceDate: item?.invoiceDate || 'NA',
      Status: item.orderStatus === 'CANCELLED' ? 'CANCELED' : item.orderStatus,
      MgmtFeeType: item?.mgmtFeeType || 'NA',
      MgmtFeeValue: '$' + item?.mgmtFeeValue?.toFixed(2),
      CustomerMgmtFee: '$' + item?.customerMgmtFee?.toFixed(2),
      CustomerTotalAmount: '$' + item?.customerTotalAmount?.toFixed(2),
    };

    if (!item.palletDetails || item.palletDetails.length === 0) {
      return [{
        ...baseData,
        PalletType: 'NA',
        Qty: 'NA',
        CustomPrice: 'NA',
        PalletPurSubTotal: 'NA',
        VendorUnitPrice: 'NA',
        TotalSoldToVendor: 'NA',
      }];
    }

    return item.palletDetails.map(pallets => ({
      ...baseData,
      PalletType: pallets?.palletType,
      Qty: pallets?.qty,
      CustomPrice: '$' + pallets?.customerPrice?.toFixed(2),
      PalletPurSubTotal: '$' + pallets?.customerSubtotal?.toFixed(2),
      VendorUnitPrice: '$' + pallets?.vendorPrice?.toFixed(2),
      TotalSoldToVendor: '$' + pallets?.vendorSubtotal?.toFixed(2),
    }));
  });

  return finalCsvData;
};

let csvFinalData = [];
const handlePtPlusOrderReportCsvExportClick = async (multiSelectCompanyVal, tabValue, tableSearch, userFilterState, setIsDownloadingPtPlusOrderReportCSV, setPtPlusCsvOrderReportData, ptPlusOrderCsvCurrentPage, setPtPlusOrderCsvCurrentPage, setPtPlusCsvTotalPages, dispatch) => {
  let data = {
    size: 100,
    number: ptPlusOrderCsvCurrentPage,
    sort: "DESC",
    companyId: multiSelectCompanyVal,
    searchBy: tableSearch || "",
    startDate: userFilterState.fromDate && formatDate(userFilterState.fromDate),
    endDate: userFilterState.toDate && formatDate(userFilterState.toDate),
  }
  let url
  if (tabValue === 'pickupOrder') url = 'ptms/admin/pickup/get_order_list'
  else if (tabValue === 'delOrder') url = 'ptms/admin/order_report_export'

  let response = await dispatch(exportPtPlusOrderReportsApi(url, data))
  if (response && response?.success) {
    let resultApiData = response?.data?.list || response?.data?.pickupOrderList
    if (!resultApiData) resultApiData = []
    const totalPages = response?.data?.totalPages ?? 1;
    setPtPlusCsvTotalPages(totalPages)
    csvFinalData.push(...resultApiData)

    if (totalPages > ptPlusOrderCsvCurrentPage + 1) {
      const nextPage = ptPlusOrderCsvCurrentPage + 1;
      setPtPlusOrderCsvCurrentPage(nextPage)

      handlePtPlusOrderReportCsvExportClick(multiSelectCompanyVal, tabValue, tableSearch, userFilterState, setIsDownloadingPtPlusOrderReportCSV, setPtPlusCsvOrderReportData, nextPage, setPtPlusOrderCsvCurrentPage, setPtPlusCsvTotalPages, dispatch)
      return;
    }

    const preparedCsvData = tabValue === 'pickupOrder' ? preparePickupOrderCsvData(csvFinalData) : prepareDelOrderCsvData(csvFinalData)
    setIsDownloadingPtPlusOrderReportCSV(false)
    setPtPlusCsvOrderReportData(preparedCsvData);

    const ptPlusOrderRportCsvExportRef = document.querySelector("#ptPlusOrderRportCsvExportRef")
    if (ptPlusOrderRportCsvExportRef) {
      setTimeout(() => {
        ptPlusOrderRportCsvExportRef.click();
      }, 500);
    }
  } else {
    setIsDownloadingPtPlusOrderReportCSV(false)
  }
}

export const ExportPtPlusOrderReport = (multiSelectCompanyVal, tabValue, tableSearch, userFilterState, setIsDownloadingPtPlusOrderReportCSV, setPtPlusCsvOrderReportData, ptPlusOrderCsvCurrentPage, setPtPlusOrderCsvCurrentPage, setPtPlusCsvTotalPages, dispatch) => {
  setIsDownloadingPtPlusOrderReportCSV(true)
  csvFinalData = [];
  handlePtPlusOrderReportCsvExportClick(multiSelectCompanyVal, tabValue, tableSearch, userFilterState, setIsDownloadingPtPlusOrderReportCSV, setPtPlusCsvOrderReportData, ptPlusOrderCsvCurrentPage, setPtPlusOrderCsvCurrentPage, setPtPlusCsvTotalPages, dispatch)
}

export const ptPlusOrderReportCSVHeaderArray = [
  { id: 'InvoiceNO', displayName: 'Invoice NO.' },
  { id: 'ReferenceNumber', displayName: 'Reference Number' },
  { id: 'PurchaseOrder', displayName: 'Purchase Order' },
  { id: 'OrderNo', displayName: 'Order No.' },
  { id: 'BillToCompanyName', displayName: 'Bill to Company Name' },
  { id: 'DeliveryLocationName', displayName: 'Delivery Location Name' },
  { id: 'DeliveryAddress', displayName: 'Delivery Address (Address 1 & 2)' },
  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'ZipCode', displayName: 'Zip Code' },
  { id: 'EquipmentRequirements', displayName: 'Equipment Requirements' },
  { id: 'Material', displayName: 'Material' },
  { id: 'Condition', displayName: 'Condition' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'Moisture', displayName: 'Moisture' },
  { id: 'Size', displayName: 'Size' },
  { id: 'Grade', displayName: 'Grade' },
  { id: 'OrderRequestDate', displayName: 'Requested Date' },
  { id: 'RequestedDeliveryDate', displayName: 'Requested Del/Pickup Date' },
  { id: 'ActualDeliveryDate', displayName: 'Actual Del/Pickup Date' },
  { id: 'Status', displayName: 'Status' },
  { id: 'Quantity', displayName: 'Quantity' },
  { id: 'FlatFee', displayName: 'Flat Fee' },
  { id: 'BidPrice', displayName: 'Bid Price' },
  { id: 'TotalAmount', displayName: 'Product Price' },
  { id: 'CustomerTaxPercentage', displayName: 'Customer Tax %' },
  { id: 'CustomerTaxAmount', displayName: 'Customer Tax Amount' },
  { id: 'ManagementFeePercentage', displayName: 'Management Fee %' },
  { id: 'ManagementFeeAmount', displayName: 'Management Fee amount' },
  { id: 'TotalInvoiceAmount', displayName: 'Total Invoice Amount' },
  { id: 'InvoiceDate', displayName: 'Invoice Date' },
  { id: 'InvoicePeriod', displayName: 'Invoice period' },
  { id: 'NetPaymentTerm', displayName: 'Net payment term' },
  { id: 'PaymentReceivedDate', displayName: 'Payment Received Date' },
  { id: 'PaymentStatus', displayName: 'Payment Status' },
  { id: 'Comments', displayName: 'Comments' },
];

export const ptPlusPickupOrderReportCSVHeaderArray = [
  { id: 'InvoiceNO', displayName: 'Invoice NO.' },
  { id: 'ReferenceNumber', displayName: 'Reference Number' },
  { id: 'PurchaseOrder', displayName: 'Purchase Order' },
  { id: 'OrderNo', displayName: 'Order No.' },
  { id: 'CreditAcc', displayName: 'Credit Account' },
  { id: 'BillToCompanyName', displayName: 'Bill to Company Name' },
  { id: 'PickupLocationName', displayName: 'Pick up Location' },
  { id: 'PickupAddress', displayName: 'Pickup Address' },
  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'ZipCode', displayName: 'Zip Code' },
  { id: 'VendorName', displayName: 'Vendor Name' },
  { id: 'EquipmentRequirements', displayName: 'Equipment Requirements' },
  { id: 'OrdReqDate', displayName: 'Order Request Date' },
  { id: 'ReqPickupDate', displayName: 'Requested Pickup Date' },
  { id: 'ActualPickupDate', displayName: 'Actual Pickup Date' },
  { id: 'InvoiceDate', displayName: 'Invoiced Date' },
  { id: 'Status', displayName: 'Status' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'Qty', displayName: 'Qty' },
  { id: 'CustomPrice', displayName: 'Customer Price' },
  { id: 'PalletPurSubTotal', displayName: 'Pallet Purchase Subtotal (Customer Subtotal)' },
  { id: 'VendorUnitPrice', displayName: 'Vendor Unit Price' },
  { id: 'TotalSoldToVendor', displayName: 'Total Pallet Sold to Vendor (Vendor Subtotal)' },
  { id: 'MgmtFeeType', displayName: 'Mgmt Fee Type' },
  { id: 'MgmtFeeValue', displayName: 'Mgmt Fee Value' },
  { id: 'CustomerMgmtFee', displayName: 'Customer Mgmt Fee' },
  { id: 'CustomerTotalAmount', displayName: 'Customer Total Amount' }
];